import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import ModalSheet from '@boschebike/ebds-react/dist-esm/components/ModalSheet.js';
import NotificationBar from '@boschebike/ebds-react/dist-esm/components/NotificationBar.js';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';
import { IconAsChunk } from '@boschebike/ebds-react-icons';

const InformationModalSheet = ({
  title,
  text,
  notification,
  close,
  dispatchHide,
}) => {
  return (
    <ModalSheet.Content type="gooseInformation">
      <Container customContentClassName="goose-modal-information">
        <div data-testid="modal-information">
          {title && <h3>{title}</h3>}
          <span dangerouslySetInnerHTML={{ __html: text }} />
          {notification && (
            <NotificationBar
              type={notification.type}
              appearance="bar"
            >
              <span dangerouslySetInnerHTML={{ __html: notification.text }} />
            </NotificationBar>
          )}
        </div>
        <div data-testid="modal-information-button">
          <Button
            name="goose-information-close"
            id="goose-information-close"
            type="button"
            mode="tertiary"
            state="normal"
            icon={<IconAsChunk iconName="CloseSmall" />}
            text={close}
            srText={close}
            onClick={() => dispatchHide()}
          />
        </div>
      </Container>
    </ModalSheet.Content>
  );
};

export default InformationModalSheet;
